// src/pages/projects/projectService.js

import {
  collection, addDoc, updateDoc, doc,
  getDocs, query, where, serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { createMaterialStage, fetchMaterialStages, migrateStageTriggersToIds } from "./projectMaterialService";

// ── HVAC Installation Standard Template ──────────────────────────────────────
// ─────────────────────────────────────────────
// CHECKLIST TEMPLATES
// ─────────────────────────────────────────────

// Template 1 — VRF/VRV System
export const TEMPLATE_VRF = [
  { item_no: 1,  item_name: "Site Inspection",                          category: "approval" },
  { item_no: 2,  item_name: "Quote Approval",                           category: "approval" },
  { item_no: 3,  item_name: "Work Order",                               category: "approval" },
  { item_no: 4,  item_name: "Advance",                                  category: "payment",  is_milestone: true, milestone_percent: 0,  milestone_label: "Advance Payment" },
  { item_no: 5,  item_name: "Whatsapp Group with all stakeholders",     category: "execution" },
  { item_no: 6,  item_name: "Shop Drawing",                             category: "documentation" },
  { item_no: 7,  item_name: "Drawing Approval",                         category: "approval" },
  { item_no: 8,  item_name: "Material Requirement",                     category: "execution" },
  { item_no: 9,  item_name: "Store Allocation at Site",                 category: "execution" },
  { item_no: 10, item_name: "Material Delivery",                        category: "execution" },
  { item_no: 11, item_name: "Marking of layouts and piping routes",     category: "execution" },
  { item_no: 12, item_name: "Laying of Copper",                         category: "execution" },
  { item_no: 13, item_name: "Laying of Communication Wires",            category: "execution" },
  { item_no: 14, item_name: "Remote Controller wiring if required",     category: "execution" },
  { item_no: 15, item_name: "Central Controller Wire if required",      category: "execution" },
  { item_no: 16, item_name: "Laying of Drain",                          category: "execution" },
  { item_no: 17, item_name: "Pressure Hold in copper tubes",            category: "execution" },
  { item_no: 18, item_name: "Drain Testing",                            category: "execution" },
  { item_no: 19, item_name: "Site ready for false ceiling works",       category: "execution" },
  { item_no: 20, item_name: "Prorata Payment of 20% of Installation cost", category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20%" },
  { item_no: 21, item_name: "Advance for Indoor Units & Remotes 100%", category: "payment",  is_milestone: true, milestone_percent: 0,  milestone_label: "Indoor Units Advance" },
  { item_no: 22, item_name: "Indoor Units Delivery",                    category: "execution" },
  { item_no: 23, item_name: "Indoor Units Installation",                category: "execution" },
  { item_no: 24, item_name: "Power Supply at Indoor Units",             category: "execution" },
  { item_no: 25, item_name: "Advance for Outdoor Units 100%",          category: "payment",  is_milestone: true, milestone_percent: 0,  milestone_label: "Outdoor Units Advance" },
  { item_no: 26, item_name: "Delivery of Outdoor Units",               category: "execution" },
  { item_no: 27, item_name: "Stands for Outdoor Units",                category: "execution" },
  { item_no: 28, item_name: "Installation of Outdoor Units",           category: "execution" },
  { item_no: 29, item_name: "Power Supply at Outdoor Units",           category: "execution" },
  { item_no: 30, item_name: "Prorata Payment of 20% of Installation cost", category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20% (2nd)" },
  { item_no: 31, item_name: "Pressure Testing of Complete System",     category: "execution" },
  { item_no: 32, item_name: "Vaccumisation of Complete System",        category: "execution" },
  { item_no: 33, item_name: "Refrigerant Calculation as per piping",   category: "execution" },
  { item_no: 34, item_name: "Refrigerant Gas Charging",                category: "execution" },
  { item_no: 35, item_name: "Commissioning of the System",             category: "execution" },
  { item_no: 36, item_name: "As built Drawings if any amendments",     category: "documentation" },
  { item_no: 37, item_name: "Handover & Final Payment of Balance 10%", category: "payment",  is_milestone: true, milestone_percent: 10, milestone_label: "Final 10%" },
];

// Template 2 — Chiller System
export const TEMPLATE_CHILLER = [
  { item_no: 1,  item_name: "Site Inspection",                    category: "approval" },
  { item_no: 2,  item_name: "Quote Approval",                     category: "approval" },
  { item_no: 3,  item_name: "Work Order",                         category: "approval" },
  { item_no: 4,  item_name: "Advance Payment",                    category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 5,  item_name: "Whatsapp Group with stakeholders",   category: "execution" },
  { item_no: 6,  item_name: "Civil foundation for chiller",       category: "execution" },
  { item_no: 7,  item_name: "Cooling tower foundation",           category: "execution" },
  { item_no: 8,  item_name: "Pump room allocation",               category: "execution" },
  { item_no: 9,  item_name: "Pipe route marking",                 category: "execution" },
  { item_no: 10, item_name: "Electrical room inspection",         category: "execution" },
  { item_no: 11, item_name: "Material delivery",                  category: "execution" },
  { item_no: 12, item_name: "Chiller unit placement",             category: "execution" },
  { item_no: 13, item_name: "Cooling tower installation",         category: "execution" },
  { item_no: 14, item_name: "Chilled water pump installation",    category: "execution" },
  { item_no: 15, item_name: "Condenser water pump installation",  category: "execution" },
  { item_no: 16, item_name: "MS/GI piping — chilled water",      category: "execution" },
  { item_no: 17, item_name: "MS/GI piping — condenser water",    category: "execution" },
  { item_no: 18, item_name: "Expansion tank installation",        category: "execution" },
  { item_no: 19, item_name: "Chemical dosing unit",               category: "execution" },
  { item_no: 20, item_name: "Pressure testing of piping",         category: "execution" },
  { item_no: 21, item_name: "Flushing of piping system",          category: "execution" },
  { item_no: 22, item_name: "Prorata 20% — after piping",        category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20% (Piping)" },
  { item_no: 23, item_name: "Power supply to chiller",            category: "execution" },
  { item_no: 24, item_name: "Power supply to cooling tower",      category: "execution" },
  { item_no: 25, item_name: "Power supply to pumps",              category: "execution" },
  { item_no: 26, item_name: "BMS/DDC panel installation",         category: "execution" },
  { item_no: 27, item_name: "Wiring & termination",               category: "execution" },
  { item_no: 28, item_name: "AHU installation",                   category: "execution" },
  { item_no: 29, item_name: "FCU installation",                   category: "execution" },
  { item_no: 30, item_name: "Duct connection to AHU",             category: "execution" },
  { item_no: 31, item_name: "Insulation of piping",               category: "execution" },
  { item_no: 32, item_name: "Prorata 20% — after AHU/FCU",       category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20% (AHU)" },
  { item_no: 33, item_name: "Water balancing",                    category: "execution" },
  { item_no: 34, item_name: "Refrigerant charging if applicable", category: "execution" },
  { item_no: 35, item_name: "Trial run & commissioning",          category: "execution" },
  { item_no: 36, item_name: "As-built drawings",                  category: "documentation" },
  { item_no: 37, item_name: "Final 10% — after commissioning",   category: "payment", is_milestone: true, milestone_percent: 10, milestone_label: "Final 10%" },
];

// Template 3 — Ducted AC
export const TEMPLATE_DUCTED = [
  { item_no: 1,  item_name: "Site Inspection",                    category: "approval" },
  { item_no: 2,  item_name: "Quote Approval",                     category: "approval" },
  { item_no: 3,  item_name: "Work Order",                         category: "approval" },
  { item_no: 4,  item_name: "Advance",                            category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 5,  item_name: "Whatsapp Group with stakeholders",   category: "execution" },
  { item_no: 6,  item_name: "Shop Drawing",                       category: "documentation" },
  { item_no: 7,  item_name: "Drawing Approval",                   category: "approval" },
  { item_no: 8,  item_name: "Material delivery",                  category: "execution" },
  { item_no: 9,  item_name: "ODU placement & stands",             category: "execution" },
  { item_no: 10, item_name: "IDU/AHU placement",                  category: "execution" },
  { item_no: 11, item_name: "GI duct fabrication",                category: "execution" },
  { item_no: 12, item_name: "GI duct installation",               category: "execution" },
  { item_no: 13, item_name: "Diffuser/grille installation",       category: "execution" },
  { item_no: 14, item_name: "Flexible duct connection",           category: "execution" },
  { item_no: 15, item_name: "Copper piping",                      category: "execution" },
  { item_no: 16, item_name: "Drain piping",                       category: "execution" },
  { item_no: 17, item_name: "Electrical wiring",                  category: "execution" },
  { item_no: 18, item_name: "Insulation of ducts",                category: "execution" },
  { item_no: 19, item_name: "Power supply to ODU",                category: "execution" },
  { item_no: 20, item_name: "Power supply to IDU",                category: "execution" },
  { item_no: 21, item_name: "False ceiling coordination",         category: "execution" },
  { item_no: 22, item_name: "Advance for equipment",              category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Equipment Advance" },
  { item_no: 23, item_name: "Air balancing",                      category: "execution" },
  { item_no: 24, item_name: "Refrigerant charging",               category: "execution" },
  { item_no: 25, item_name: "Commissioning & trial run",          category: "execution" },
  { item_no: 26, item_name: "As-built drawings",                  category: "documentation" },
  { item_no: 27, item_name: "Prorata 20% — mid installation",    category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20%" },
  { item_no: 28, item_name: "Final 10% on handover",             category: "payment", is_milestone: true, milestone_percent: 10, milestone_label: "Final 10%" },
];

// Template 4 — Split/Cassette AC
export const TEMPLATE_SPLIT = [
  { item_no: 1,  item_name: "Site Inspection",                    category: "approval" },
  { item_no: 2,  item_name: "Quote Approval",                     category: "approval" },
  { item_no: 3,  item_name: "Work Order + Advance",               category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 4,  item_name: "Material delivery",                  category: "execution" },
  { item_no: 5,  item_name: "Indoor unit installation",           category: "execution" },
  { item_no: 6,  item_name: "Outdoor unit placement & stands",    category: "execution" },
  { item_no: 7,  item_name: "Copper piping",                      category: "execution" },
  { item_no: 8,  item_name: "Drain piping",                       category: "execution" },
  { item_no: 9,  item_name: "Electrical wiring",                  category: "execution" },
  { item_no: 10, item_name: "Power supply to ODU",                category: "execution" },
  { item_no: 11, item_name: "Gas charging if required",           category: "execution" },
  { item_no: 12, item_name: "Trial run",                          category: "execution" },
  { item_no: 13, item_name: "Handover",                           category: "documentation" },
  { item_no: 14, item_name: "As-built if any",                    category: "documentation" },
  { item_no: 15, item_name: "Final payment on handover",          category: "payment", is_milestone: true, milestone_percent: 100, milestone_label: "Final Payment" },
];

// Template 5 — Precision AC / Server Room
export const TEMPLATE_PRECISION = [
  { item_no: 1,  item_name: "Site Inspection",                    category: "approval" },
  { item_no: 2,  item_name: "Quote Approval",                     category: "approval" },
  { item_no: 3,  item_name: "Work Order",                         category: "approval" },
  { item_no: 4,  item_name: "Advance",                            category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 5,  item_name: "Raised floor inspection",            category: "execution" },
  { item_no: 6,  item_name: "Hot aisle/cold aisle planning",      category: "execution" },
  { item_no: 7,  item_name: "Material delivery",                  category: "execution" },
  { item_no: 8,  item_name: "Precision AC unit placement",        category: "execution" },
  { item_no: 9,  item_name: "Condenser unit placement",           category: "execution" },
  { item_no: 10, item_name: "Copper piping (insulated)",          category: "execution" },
  { item_no: 11, item_name: "Drain connection",                   category: "execution" },
  { item_no: 12, item_name: "Electrical wiring",                  category: "execution" },
  { item_no: 13, item_name: "UPS/DB connection",                  category: "execution" },
  { item_no: 14, item_name: "Precision control panel",            category: "execution" },
  { item_no: 15, item_name: "Humidification unit if applicable",  category: "execution" },
  { item_no: 16, item_name: "Leak detection sensor",              category: "execution" },
  { item_no: 17, item_name: "Gas charging",                       category: "execution" },
  { item_no: 18, item_name: "Trial run — 24hr monitoring",        category: "execution" },
  { item_no: 19, item_name: "As-built drawings",                  category: "documentation" },
  { item_no: 20, item_name: "Final payment on commissioning",     category: "payment", is_milestone: true, milestone_percent: 100, milestone_label: "Final Payment" },
];

// Template 6 — Ventilation/AHU Only
export const TEMPLATE_VENTILATION = [
  { item_no: 1,  item_name: "Site Inspection",                    category: "approval" },
  { item_no: 2,  item_name: "Quote + Work Order",                 category: "approval" },
  { item_no: 3,  item_name: "Advance",                            category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 4,  item_name: "Material delivery",                  category: "execution" },
  { item_no: 5,  item_name: "AHU placement",                      category: "execution" },
  { item_no: 6,  item_name: "Supply air duct",                    category: "execution" },
  { item_no: 7,  item_name: "Return air duct",                    category: "execution" },
  { item_no: 8,  item_name: "Fresh air intake",                   category: "execution" },
  { item_no: 9,  item_name: "Exhaust duct",                       category: "execution" },
  { item_no: 10, item_name: "Dampers installation",               category: "execution" },
  { item_no: 11, item_name: "Grilles & diffusers",                category: "execution" },
  { item_no: 12, item_name: "Electrical wiring to AHU",           category: "execution" },
  { item_no: 13, item_name: "VFD installation if applicable",     category: "execution" },
  { item_no: 14, item_name: "Fire dampers if required",           category: "execution" },
  { item_no: 15, item_name: "Prorata 20% — mid installation",    category: "payment", is_milestone: true, milestone_percent: 20, milestone_label: "Prorata 20%" },
  { item_no: 16, item_name: "Air balancing",                      category: "execution" },
  { item_no: 17, item_name: "Trial run",                          category: "execution" },
  { item_no: 18, item_name: "As-built drawings",                  category: "documentation" },
  { item_no: 19, item_name: "Final payment on completion",        category: "payment", is_milestone: true, milestone_percent: 100, milestone_label: "Final Payment" },
];

// Template 7 — Supply Only
export const TEMPLATE_SUPPLY = [
  { item_no: 1, item_name: "Order Confirmation",                  category: "approval" },
  { item_no: 2, item_name: "Advance Payment",                     category: "payment", is_milestone: true, milestone_percent: 0, milestone_label: "Advance" },
  { item_no: 3, item_name: "Material Procurement",                category: "execution" },
  { item_no: 4, item_name: "Quality Check at warehouse",          category: "execution" },
  { item_no: 5, item_name: "Delivery to site",                    category: "execution" },
  { item_no: 6, item_name: "Unloading & site check",              category: "execution" },
  { item_no: 7, item_name: "Client sign-off on delivery",         category: "documentation" },
  { item_no: 8, item_name: "Balance payment",                     category: "payment", is_milestone: true, milestone_percent: 100, milestone_label: "Final Payment" },
];

// Template 8 — AMC Visit
export const TEMPLATE_AMC = [
  { item_no: 1,  item_name: "Schedule confirmation",              category: "approval" },
  { item_no: 2,  item_name: "Spare parts checklist",              category: "execution" },
  { item_no: 3,  item_name: "Filter cleaning",                    category: "execution" },
  { item_no: 4,  item_name: "Coil cleaning",                      category: "execution" },
  { item_no: 5,  item_name: "Drain pan cleaning",                 category: "execution" },
  { item_no: 6,  item_name: "Blower cleaning",                    category: "execution" },
  { item_no: 7,  item_name: "Condenser coil cleaning",            category: "execution" },
  { item_no: 8,  item_name: "Electrical connections check",       category: "execution" },
  { item_no: 9,  item_name: "Refrigerant pressure check",         category: "execution" },
  { item_no: 10, item_name: "Trial run",                          category: "execution" },
  { item_no: 11, item_name: "Temperature check",                  category: "execution" },
  { item_no: 12, item_name: "Service report sign-off",            category: "documentation" },
];

// ── TEMPLATE MAP ─────────────────────────────────────────────────────────────
export const TEMPLATE_MAP = {
  vrf:         { label: "VRF/VRV System",        items: null, key: "vrf" },
  chiller:     { label: "Chiller System",         items: null, key: "chiller" },
  ducted:      { label: "Ducted AC",              items: null, key: "ducted" },
  split:       { label: "Split/Cassette AC",      items: null, key: "split" },
  precision:   { label: "Precision AC/Server Room", items: null, key: "precision" },
  ventilation: { label: "Ventilation/AHU Only",   items: null, key: "ventilation" },
  supply:      { label: "Supply Only",            items: null, key: "supply" },
  amc:         { label: "AMC Visit",              items: null, key: "amc" },
  none:        { label: "No Template (Custom)",   items: null, key: "none" },
};

export const getTemplateItems = (key) => {
  const map = {
    vrf:         TEMPLATE_VRF,
    chiller:     TEMPLATE_CHILLER,
    ducted:      TEMPLATE_DUCTED,
    split:       TEMPLATE_SPLIT,
    precision:   TEMPLATE_PRECISION,
    ventilation: TEMPLATE_VENTILATION,
    supply:      TEMPLATE_SUPPLY,
    amc:         TEMPLATE_AMC,
  };
  return map[key] || [];
};

// Legacy export — backward compat
export const HVAC_INSTALLATION_TEMPLATE = TEMPLATE_VRF;

// ── MATERIAL STAGE TEMPLATES ─────────────────────────────────────────────────
export const getMaterialStageTemplate = (key) => {
  const templates = {

    vrf: [
      {
        stage_name:    "Stage 1 — Civil & Piping",
        trigger_items: [10], // Material Delivery
        material_budget: [
          { item_name: "Copper Pipe 1/4\"",    unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Copper Pipe 3/8\"",    unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Copper Pipe 1/2\"",    unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Insulation Tape",      unit: "Rmt", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Drain Pipe",           unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Communication Wire",   unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
      {
        stage_name:    "Stage 2 — Indoor Units",
        trigger_items: [21], // Advance for Indoor Units
        material_budget: [
          { item_name: "IDU Cassette/Wall",    unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Remote Controller",    unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Indoor Power Cable",   unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
      {
        stage_name:    "Stage 3 — Outdoor Units & Commissioning",
        trigger_items: [25], // Advance for Outdoor Units
        material_budget: [
          { item_name: "VRF ODU",              unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "ODU Stand/Base Frame", unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Refrigerant R32",      unit: "Kg",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Outdoor Power Cable",  unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    chiller: [
      {
        stage_name:    "Stage 1 — Civil & Piping",
        trigger_items: [11], // Material delivery
        material_budget: [
          { item_name: "MS Pipe",              unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "GI Pipe",              unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Pipe Insulation",      unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Valves",               unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Expansion Tank",       unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
      {
        stage_name:    "Stage 2 — Chiller & Cooling Tower",
        trigger_items: [12], // Chiller unit placement
        material_budget: [
          { item_name: "Chiller Unit",         unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Cooling Tower",        unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Chilled Water Pump",   unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Condenser Pump",       unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
      {
        stage_name:    "Stage 3 — AHU/FCU & Electrical",
        trigger_items: [28], // AHU installation
        material_budget: [
          { item_name: "AHU Unit",             unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "FCU Unit",             unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Power Cable",          unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "BMS Panel",            unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    ducted: [
      {
        stage_name:    "Stage 1 — Duct & Piping",
        trigger_items: [8], // Material delivery
        material_budget: [
          { item_name: "GI Sheet Duct",        unit: "Sqft", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Flexible Duct",        unit: "Mtr",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Copper Pipe",          unit: "Mtr",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Diffusers/Grilles",    unit: "Nos",  qty_budgeted: 0, cost_rate: 0 },
        ],
      },
      {
        stage_name:    "Stage 2 — Equipment",
        trigger_items: [22], // Advance for equipment
        material_budget: [
          { item_name: "IDU/AHU Unit",         unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "ODU Unit",             unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Refrigerant",          unit: "Kg",  qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    split: [
      {
        stage_name:    "Stage 1 — Equipment & Installation",
        trigger_items: [4], // Material delivery
        material_budget: [
          { item_name: "Split IDU",            unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Split ODU",            unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Copper Pipe",          unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Drain Pipe",           unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Refrigerant",          unit: "Kg",  qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    precision: [
      {
        stage_name:    "Stage 1 — Precision AC Equipment",
        trigger_items: [7], // Material delivery
        material_budget: [
          { item_name: "Precision AC Unit",    unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Condenser Unit",       unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Copper Pipe",          unit: "Mtr", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Leak Detection Sensor", unit: "Nos", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Refrigerant",          unit: "Kg",  qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    ventilation: [
      {
        stage_name:    "Stage 1 — Duct & AHU",
        trigger_items: [4], // Material delivery
        material_budget: [
          { item_name: "AHU Unit",             unit: "Nos",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "GI Duct",              unit: "Sqft", qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Dampers",              unit: "Nos",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "Grilles/Diffusers",    unit: "Nos",  qty_budgeted: 0, cost_rate: 0 },
          { item_name: "VFD",                  unit: "Nos",  qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    supply: [
      {
        stage_name:    "Stage 1 — Supply & Delivery",
        trigger_items: [3], // Material Procurement
        material_budget: [
          { item_name: "Equipment/Material",   unit: "Lot", qty_budgeted: 0, cost_rate: 0 },
        ],
      },
    ],

    amc: [], // AMC mein material stages nahi hoti
  };

  return templates[key] || [];
};

// ── Create Project ────────────────────────────────────────────────────────────
export const createProject = async (data, user) => {
  const company_id = user.company_id || "";

  const projectRef = await addDoc(collection(db, "projects"), {
    company_id,
    project_name:  data.project_name,
    client_id:     data.client_id     || "",
    client_name:   data.client_name   || "",
    site_id:       data.site_id       || "",
    site_name:     data.site_name     || "",
    project_type:  data.project_type  || "installation",
    total_value:   Number(data.total_value || 0),
    start_date:    data.start_date    || "",
    end_date:      data.end_date      || "",
    description:   data.description   || "",
    contacts:      data.contacts      || [],
    assigned_team: data.assigned_team || [],
    status:        "active",
    amc_contract_ids: [],
    created_by:      user.uid || user.id || "",
    created_by_name: user.name || "",
    created_at:      serverTimestamp(),
    updated_at:      serverTimestamp(),
  });

  // ── Auto-load checklist from template — now HIERARCHICAL ──────────────────
  // Each distinct category (approval/payment/execution/documentation) becomes
  // a real category NODE (own doc, parent_id: null), not just a string label.
  // This lets the client later add sub-categories under any category (e.g.
  // Execution → "1st Floor" → "Piping done") without touching other projects
  // or the master template. item_no is kept only as a legacy display label —
  // it is never used to link Material Stages anymore (see D-1XX).
  // Namespaced by trade to avoid item_no collisions across multiple selected
  // trade templates (each template's own item_no sequence restarts at 1) —
  // currently unused by any later code in this function, kept only for
  // parity with the original single-template shape in case a future
  // feature (e.g. per-trade stage-trigger linking) needs it.
  const itemNoToId = {};

  if (data.load_template) {
    // Backward compat: accept either the legacy single `template_key`
    // string (still sent by Quotation-convert / Enquiry-convert) or the new
    // `template_keys` array (multi-trade, from the updated ProjectCreate UI).
    // A single legacy key behaves exactly as before, just routed through
    // the same per-trade loop below.
    const tradeKeys = Array.isArray(data.template_keys) && data.template_keys.length > 0
      ? data.template_keys
      : [data.template_key || "vrf"];

    // Running order counter across ALL selected trades' category nodes —
    // keeps every trade's categories in a stable, non-overlapping sibling
    // order (first selected trade's categories first, then the next
    // trade's, etc.) instead of resetting per trade.
    let categoryOrderCounter = 0;

    for (const tradeKey of tradeKeys) {
      const template = getTemplateItems(tradeKey);
      if (template.length === 0) continue; // guards an invalid/unknown key

      // 1) One category-node per distinct category IN THIS TEMPLATE, in
      //    first-seen order, tagged with `trade: tradeKey`. Categories are
      //    NEVER merged/deduped across trades — e.g. if two selected
      //    trades both have "Execution", this produces TWO separate
      //    top-level category nodes (each tagged to its own trade), never
      //    one merged category. Mixing two trades' items under one shared
      //    category would silently corrupt per-trade tracking (progress,
      //    trigger-linking) with no way to tell them apart later. Execution
      //    defaults to tech_visible:true; all other categories default to
      //    false (office-only) — unchanged from before.
      const categoryOrderThisTrade = [];
      template.forEach(item => {
        if (!categoryOrderThisTrade.includes(item.category)) categoryOrderThisTrade.push(item.category);
      });

      const categoryIds = {};
      for (const catKey of categoryOrderThisTrade) {
        categoryOrderCounter += 1000;
        const catRef = await addDoc(collection(db, "project_checklist_items"), {
          company_id,
          project_id:      projectRef.id,
          project_name:    data.project_name,
          parent_id:       null,
          node_type:       "category",
          order:           categoryOrderCounter,
          item_name:       catKey.charAt(0).toUpperCase() + catKey.slice(1),
          category:        catKey, // legacy display field, kept for backward compat
          trade:           tradeKey, // NEW — which template this category came from
          tech_visible:    catKey === "execution",
          is_active:       true,
          created_by:      user.uid || user.id || "",
          created_by_name: user.name || "",
          created_at:      serverTimestamp(),
          updated_at:      serverTimestamp(),
        });
        categoryIds[catKey] = catRef.id;
      }

      // 2) Each template item as a child of its (trade-specific) category
      //    node. Item nodes themselves are NOT tagged with trade — they
      //    inherit it visually via their parent category.
      const orderCounter = {};
      for (const item of template) {
        orderCounter[item.category] = (orderCounter[item.category] || 0) + 10;
        const itemRef = await addDoc(collection(db, "project_checklist_items"), {
          company_id,
          project_id:        projectRef.id,
          project_name:      data.project_name,
          parent_id:         categoryIds[item.category],
          node_type:         "item",
          order:             orderCounter[item.category],
          item_no:           item.item_no, // legacy label only — display + old-stage fallback
          item_name:         item.item_name,
          category:          item.category, // legacy display field
          is_milestone:      item.is_milestone      || false,
          milestone_percent: item.milestone_percent ?? null,
          milestone_label:   item.milestone_label   || "",
          status:            "pending",
          assigned_to:       "",
          assigned_to_name:  "",
          completed_by:      "",
          completed_by_name: "",
          completed_on:      null,
          remarks:           "",
          is_active:         true,
          created_by:      user.uid || user.id || "",
          created_by_name: user.name || "",
          created_at:      serverTimestamp(),
          updated_at:      serverTimestamp(),
        });
        itemNoToId[`${tradeKey}_${item.item_no}`] = itemRef.id;
      }
    }
  }

  // ⚠️ Auto-created material stages REMOVED (per team decision, 16 Jul 2026).
  // Previously, 2-4 hardcoded placeholder stages (with qty_budgeted: 0,
  // cost_rate: 0 — no real budget data) were auto-created here per HVAC
  // template. This produced confusing "empty" stages sitting alongside real
  // stages from AI-BOQ-Import or manual entry, made stage numbering start
  // at 4+ instead of 1 on every new project, and gave every project fake
  // "Stage 1/2/3" placeholders nobody used. Material stages are now created
  // ONLY via: AI Smart BOQ Import, manual "Upload BOQ (Template)", or
  // "+ New Stage" — never automatically from a checklist template.
  // getMaterialStageTemplate() is left in this file (unused) rather than
  // deleted, in case a future feature wants opt-in template-based stage
  // seeding — but it must never be called automatically from createProject()
  // again without an explicit, visible user choice to do so.

  return projectRef.id;
};

// ── Update Project ────────────────────────────────────────────────────────────
export const updateProject = async (projectId, data) => {
  await updateDoc(doc(db, "projects", projectId), {
    ...data,
    updated_at: serverTimestamp(),
  });
};

// ── Update Checklist Item ─────────────────────────────────────────────────────
export const updateChecklistItem = async (itemId, data) => {
  await updateDoc(doc(db, "project_checklist_items", itemId), {
    ...data,
    updated_at: serverTimestamp(),
  });
};

// ── Fetch Checklist Items — flat, leaves only ────────────────────────────────
// Excludes category/group nodes and soft-deleted items; legacy-safe (works
// identically on old flat-shape projects, since node_type/is_active default
// to "item"/true when absent).
export const fetchChecklistItems = async (projectId, companyId) => {
  const q = query(
    collection(db, "project_checklist_items"),
    where("project_id", "==", projectId),
    where("company_id", "==", companyId)
  );
  const snap = await getDocs(q);
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(i => (i.node_type || "item") === "item" && i.is_active !== false)
    .sort((a, b) => (a.order ?? a.item_no ?? 0) - (b.order ?? b.item_no ?? 0));
};

// ── Centralized progress calculator ──────────────────────────────────────────
export const calculateProjectProgress = (items = []) => {
  // Defensive filter: category/group nodes never count toward progress —
  // only real checklist items (leaves) do, even if a category node is
  // accidentally passed in by a future caller.
  const leaves = items.filter(i => (i.node_type || "item") === "item" && i.is_active !== false);
  const total      = leaves.length;
  const na         = leaves.filter(i => i.status === "n/a").length;
  const completed  = leaves.filter(i => i.status === "completed").length;
  const applicable = total - na;
  const pct        = applicable > 0
    ? Math.round((completed / applicable) * 100) : 0;
  const milestones        = leaves.filter(i => i.is_milestone);
  const pendingMilestones = milestones.filter(i => i.status !== "completed").length;
  return { total, completed, na, applicable, pct, milestones, pendingMilestones };
};
// ═══════════════════════════════════════════════════════════════════════════
// HIERARCHICAL CHECKLIST — tree build, migration, CRUD
// ═══════════════════════════════════════════════════════════════════════════

// ── Build nested tree from a flat list of checklist item docs ───────────────
export const buildChecklistTree = (flatItems) => {
  const byId = new Map();
  flatItems.forEach(item => byId.set(item.id, { ...item, children: [] }));

  const roots = [];
  byId.forEach(node => {
    if (node.parent_id && byId.has(node.parent_id)) {
      byId.get(node.parent_id).children.push(node);
    } else {
      roots.push(node);
    }
  });

  const sortRec = (nodes) => {
    nodes.sort((a, b) => (a.order ?? a.item_no ?? 0) - (b.order ?? b.item_no ?? 0));
    nodes.forEach(n => sortRec(n.children));
  };
  sortRec(roots);
  return roots;
};

// ── One-time, idempotent migration: legacy flat checklist → hierarchical ────
// Runs automatically the first time a project's checklist is opened after
// this feature ships. Detects legacy shape (no item has node_type set),
// wraps existing items under real category-node docs — using the SAME 4
// categories they already had (approval/payment/execution/documentation) in
// the SAME display order — and back-fills any existing Material Stage's
// trigger_item_ids using the item_no → item_id map built here. Safe to call
// more than once: no-op if this project was already migrated.
export const migrateLegacyChecklistToHierarchy = async (projectId, companyId, user) => {
  const q = query(
    collection(db, "project_checklist_items"),
    where("project_id", "==", projectId),
    where("company_id", "==", companyId)
  );
  const snap = await getDocs(q);
  const rawItems = snap.docs.map(d => ({ id: d.id, ...d.data() }));

  const alreadyMigrated = rawItems.some(i => i.node_type !== undefined);
  if (alreadyMigrated || rawItems.length === 0) return { migrated: false };

  const CATEGORY_ORDER = ["approval", "payment", "execution", "documentation"];
  const presentCategories = CATEGORY_ORDER.filter(cat =>
    rawItems.some(i => (i.category || "execution") === cat)
  );

  const categoryIds = {};
  for (let ci = 0; ci < presentCategories.length; ci++) {
    const catKey = presentCategories[ci];
    const catRef = await addDoc(collection(db, "project_checklist_items"), {
      company_id:      companyId,
      project_id:      projectId,
      project_name:    rawItems[0]?.project_name || "",
      parent_id:       null,
      node_type:       "category",
      order:           ci * 1000,
      item_name:       catKey.charAt(0).toUpperCase() + catKey.slice(1),
      category:        catKey,
      tech_visible:    catKey === "execution",
      is_active:       true,
      created_by:      user.uid || user.id || "",
      created_by_name: user.name || "",
      created_at:      serverTimestamp(),
      updated_at:      serverTimestamp(),
    });
    categoryIds[catKey] = catRef.id;
  }

  const itemNoToId = {};
  for (const item of rawItems) {
    const catKey = item.category || "execution";
    await updateDoc(doc(db, "project_checklist_items", item.id), {
      parent_id:  categoryIds[catKey] || null,
      node_type:  "item",
      order:      (item.item_no || 0) * 10,
      is_active:  true,
      updated_at: serverTimestamp(),
    });
    if (item.item_no) itemNoToId[item.item_no] = item.id;
  }

  // Close the trigger-fragility gap permanently for this project's stages —
  // any existing Material Stage now points at real item IDs, not positions.
  try {
    await migrateStageTriggersToIds(companyId, projectId, itemNoToId);
  } catch (err) {
    console.error("migrateStageTriggersToIds failed (non-blocking):", err);
  }

  return { migrated: true, categoriesCreated: presentCategories.length, itemsMigrated: rawItems.length };
};

// ── Fetch + auto-migrate + build tree, in one call ───────────────────────────
export const fetchChecklistTree = async (projectId, companyId, user) => {
  await migrateLegacyChecklistToHierarchy(projectId, companyId, user);

  const q = query(
    collection(db, "project_checklist_items"),
    where("project_id", "==", projectId),
    where("company_id", "==", companyId)
  );
  const snap = await getDocs(q);
  const flat = snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(i => i.is_active !== false);

  return buildChecklistTree(flat);
};

// ── Add a checklist node — category OR item ──────────────────────────────────
export const addChecklistNode = async ({
  project_id, project_name, company_id,
  parent_id = null, node_type = "item", item_name,
  is_milestone = false, milestone_percent = null, milestone_label = "",
}, user) => {
  if (!item_name?.trim()) throw new Error("Name required");

  // New node goes to the end of its sibling group
  const q = query(
    collection(db, "project_checklist_items"),
    where("project_id", "==", project_id),
    where("company_id", "==", company_id)
  );
  const snap = await getDocs(q);
  const siblings = snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .filter(i => (i.parent_id || null) === parent_id && i.is_active !== false);
  const finalOrder = siblings.reduce((m, s) => Math.max(m, s.order ?? 0), 0) + 10;

  const payload = {
    company_id,
    project_id,
    project_name:    project_name || "",
    parent_id,
    node_type,
    order:           finalOrder,
    item_name:       item_name.trim(),
    is_active:       true,
    created_by:      user.uid || user.id || "",
    created_by_name: user.name || "",
    created_at:      serverTimestamp(),
    updated_at:      serverTimestamp(),
  };

  if (node_type === "category") {
    payload.tech_visible = false; // manager turns this on explicitly after creating
  } else {
    payload.status            = "pending";
    payload.assigned_to       = "";
    payload.assigned_to_name  = "";
    payload.completed_by      = "";
    payload.completed_by_name = "";
    payload.completed_on      = null;
    payload.remarks           = "";
    payload.is_milestone      = is_milestone;
    payload.milestone_percent = milestone_percent;
    payload.milestone_label   = milestone_label;
  }

  const ref = await addDoc(collection(db, "project_checklist_items"), payload);
  return ref.id;
};

// ── Rename a node (category title or item name) ──────────────────────────────
export const renameChecklistNode = async (itemId, newName) => {
  if (!newName?.trim()) throw new Error("Name required");
  await updateDoc(doc(db, "project_checklist_items", itemId), {
    item_name:  newName.trim(),
    updated_at: serverTimestamp(),
  });
};

// ── Toggle technician visibility — meaningful on top-level categories ───────
export const setCategoryTechVisibility = async (itemId, visible) => {
  await updateDoc(doc(db, "project_checklist_items", itemId), {
    tech_visible: Boolean(visible),
    updated_at:   serverTimestamp(),
  });
};

// ── Check whether any of these item IDs are linked to a Material Stage ──────
// Call this BEFORE deleting a node so the manager can be warned instead of
// silently orphaning a stage's unlock trigger.
export const findLinkedStageNames = async (company_id, project_id, itemIds) => {
  const stages = await fetchMaterialStages(company_id, project_id);
  const linked = [];
  for (const stage of stages) {
    const hit = (stage.trigger_item_ids || []).some(id => itemIds.includes(id));
    if (hit) linked.push(stage.stage_name);
  }
  return linked;
};

// ── Soft-delete a node and all of its descendants ────────────────────────────
// Caller (UI) passes the FULL list of ids to remove — for a category this is
// the category's own id plus every descendant id (computed client-side from
// the already-fetched tree, via collectDescendantIds below). Soft delete
// only — never hard delete — matching the ledger/data-integrity rule used
// everywhere else in this codebase; a deleted node can be restored by an
// admin if needed.
export const deleteChecklistNodes = async (itemIds) => {
  await Promise.all(itemIds.map(id =>
    updateDoc(doc(db, "project_checklist_items", id), {
      is_active:  false,
      deleted_at: serverTimestamp(),
    })
  ));
};

// ── Helper: collect a node's own id + every descendant id from a tree node ──
export const collectDescendantIds = (node) => {
  let ids = [node.id];
  (node.children || []).forEach(child => {
    ids = ids.concat(collectDescendantIds(child));
  });
  return ids;
};
// ── Convert an existing item into a category (so it can hold sub-items) ─────
// Use case: manager realizes a leaf task like "Laying of Copper" actually
// needs floor/zone-wise breakdown after the fact. Converting keeps the node
// in place (same parent, same position) but flips it from a trackable task
// into a container — its own status/milestone fields become irrelevant
// (categories never count toward progress; see countProgress in
// ProjectChecklist.jsx) and can simply be left as historical residue.
// Never call this on a milestone item — the UI blocks that entirely, since
// milestone invoicing depends on an item having its own status.
export const convertItemToCategory = async (itemId) => {
  await updateDoc(doc(db, "project_checklist_items", itemId), {
    node_type:  "category",
    updated_at: serverTimestamp(),
  });
};
// ── Swap the sibling order of two nodes — powers the Up/Down reorder buttons ──
// Falls back to item_no when order is missing (legacy items) — same fallback
// pattern used everywhere else in this file for backward compatibility.
export const swapChecklistNodeOrder = async (nodeAId, nodeAOrder, nodeBId, nodeBOrder) => {
  await Promise.all([
    updateDoc(doc(db, "project_checklist_items", nodeAId), {
      order:      nodeBOrder,
      updated_at: serverTimestamp(),
    }),
    updateDoc(doc(db, "project_checklist_items", nodeBId), {
      order:      nodeAOrder,
      updated_at: serverTimestamp(),
    }),
  ]);
};
// ── Projects a technician has actual assigned work in ───────────────────────
// A technician should only see projects where they have at least one
// service_task assigned — never the full company project list. Derived from
// service_tasks.assigned_tech_ids (array-contains), not stored redundantly
// anywhere, so it always reflects current assignments with no separate
// sync step needed.
export const fetchProjectsForTechnician = async (company_id, tech_uid) => {
  const tasksSnap = await getDocs(query(
    collection(db, "service_tasks"),
    where("company_id", "==", company_id),
    where("assigned_tech_ids", "array-contains", tech_uid)
  ));

  const projectIds = [...new Set(
    tasksSnap.docs.map(d => d.data().project_id).filter(Boolean)
  )];
  if (!projectIds.length) return [];

  // Firestore "in" queries are capped at 10 values — batch if a technician
  // somehow has tasks across more than 10 distinct projects.
  const batches = [];
  for (let i = 0; i < projectIds.length; i += 10) {
    batches.push(projectIds.slice(i, i + 10));
  }

  const results = await Promise.all(batches.map(batchIds =>
    getDocs(query(collection(db, "projects"), where("__name__", "in", batchIds)))
  ));

  const projects = [];
  results.forEach(snap => snap.docs.forEach(d => projects.push({ id: d.id, ...d.data() })));
  return projects;
};  